export const hasDuplicateInclusionCondition = <T>(
    conditions: readonly T[],
    candidate: T,
    selected: T | null,
    hasSameObject: (item: T, comparedItem: T | null) => boolean,
): boolean =>
    conditions.some((condition) => {
        if (selected !== null && hasSameObject(condition, selected)) {
            return false;
        }

        return hasSameObject(condition, candidate);
    });
